export default __webpack_public_path__ + "static/media/sub1month.76aea72c.png";